import log from 'salvo-lite/log'
import axios from 'axios'

class Search {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.getAttribute('data-search'))
        this._searchInput = elem.querySelector(this._options.input)
        this._termsText = elem.querySelector(this._options.termsText)
        this._suggestedTermsContainer = elem.querySelector(this._options.suggestedTermsContainer)
        this._suggestedItemsContainer = elem.querySelector(this._options.suggestedItemsContainer)
        this._loadingAnimation = elem.querySelector(this._options.loadingAnimation)
        this._productResults = document.querySelector('[data-product-results]')
        this._paginateNext = []
        this._url = window.location.origin + '/search?q='
        this._idleTimer = null
        this._collectionTabEnd = false
        this._closeBtns = document.querySelectorAll('[data-search-close]')

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this.initInputListener()

        if (window.location.href.includes('search?q=')) {
            this.initCollectionSearch()
        }

        this.initCloseBtns()

        this.search('', 'suggest')
    }

    initInputListener () {
        this._searchInput.addEventListener('input', event => {
            if (!document.querySelector('.search-box__input').classList.contains('active')) {
                document.querySelector('.search-box__input').classList.add('active')
            }

            if (!document.querySelector('.search-box__suggestions').classList.contains('active')) {
                document.querySelector('.search-box__suggestions').classList.add('active')
            }

            const value = event.target.value.split('').map(char => char.toLowerCase()).join('')

            this._loadingAnimation.classList.add('active')

            this.delayUpdate(value, 'suggest')

            window.addEventListener('keydown', event => {
                if (event.key === 'Enter' && value !== '') {
                    this.search(value, 'submit')
                }
            })
        })
    }

    initCollectionSearch () {
        const collectionBtn = document.querySelector('[data-collection-btn]')
        const collectionContainer = document.querySelector('#collection-results')
        const allCollectionData = [...document.querySelectorAll('[data-collection-item]')]

        const params = new URLSearchParams(window.location.search)
        const query = params.get('q')

        collectionBtn.addEventListener('click', () => {
            allCollectionData.forEach(item => {
                const collectionJSON = JSON.parse(item.getAttribute('data-collection-item'))
                const image = collectionJSON.image
                const title = collectionJSON.title
                const url = collectionJSON.url

                const raw = `
                    <a href="${url}">
                        <div class="search-collection-item__image"> 
                            <img src="${image}" />
                        </div>
                        <h3 class="search-collection-item__title text-align-center">${title}</h3>
                    </a>
                `
                const collectionItem = document.createElement('div')
                collectionItem.classList.add('search-collection-item')
                collectionItem.innerHTML = raw

                const _title = title.split('').map(char => char.toLowerCase()).join('')

                if ((_title.includes(query) || query.includes(_title)) && !this._collectionTabEnd) {
                    collectionContainer.appendChild(collectionItem)
                }
            })

            this._collectionTabEnd = true
        })
    }

    delayUpdate (query) {
        clearTimeout(this._idleTimer)
        this._idleTimer = setTimeout(() => this.search(query, 'suggest'), 500)
    }

    async search (query, type) {
        const termsText = query.split('').map(char => char.toUpperCase()).join('')

        if (query === '') {
            this._termsText.innerHTML = 'SUGGESTED PRODUCTS'
        } else {
            this._termsText.innerHTML = 'PRODUCTS FOR "' + termsText + '"'
        }

        const searchURL = this._url + query

        if (type === 'suggest') {
            try {
                const response = await axios.get(searchURL + '*' + '&type=product')

                const htmlHold = document.createElement('div')
                htmlHold.innerHTML = response.data

                const results = htmlHold.querySelector('#all-results')
                const suggestedResults = results.querySelector('#suggested-results')

                this._suggestedTermsContainer.innerHTML = ''
                this.buildSuggestedTerms(suggestedResults, query)

                this._suggestedItemsContainer.innerHTML = ''
                this.buildSuggestedProducts(suggestedResults)
            } catch (error) {
                console.log(error)
            }
        }

        if (type === 'submit') {
            window.location.href = '/search?q=' + query + '*'
        }

        this._loadingAnimation.classList.remove('active')
    }

    buildSuggestedTerms (results, query) {
        let suggestedTerms = [...results.querySelectorAll('.suggested-terms')]

        if (!suggestedTerms.length) {
            this._suggestedTermsContainer.innerHTML = 'No terms found for "' + query + '"'
            return
        }

        let hash = {}

        let breakCounter = 0
        let index = 0
        let limit = suggestedTerms.length < 10 ? suggestedTerms.length : 10

        while (breakCounter < limit) {
            if (!suggestedTerms[index]) {
                break
            }

            const term = suggestedTerms[index].getAttribute('data-term')

            if (!hash.hasOwnProperty(term)) {
                this._suggestedTermsContainer.appendChild(suggestedTerms[index])
                hash[term] = true
                breakCounter += 1
            }

            index += 1
        }
    }

    buildSuggestedProducts (results) {
        const suggestedProducts = results.querySelectorAll('.search-result')

        let limit = 4
        if (window.innerWidth < 601) {
            limit = 3
        }

        if (window.innerHeight < 675) {
            limit = 2
        }

        for (let i = 0; i < limit; i++) {
            const product = suggestedProducts[i]
            const productJSON = JSON.parse(product.getAttribute('data-suggested-product'))

            const { image, collection, info } = productJSON

            const src = image.src
            const alt = image.alt

            let collectionText = ''

            if (collection) {
                const collectionURL = collection.url
                const collectionTitle = collection.title

                collectionText = '<a class="suggested-product__collection-text" href="' + collectionURL + '">' + collectionTitle + '</a>'
            }

            const productURL = info.url
            const productTitle = info.title
            const productPrice = info.price
            const colorsCounter = info.counter

            let colorsCounterText = ''

            if (colorsCounter > 1) {
                colorsCounterText = 'Available in ' + colorsCounter + ' more colors'
            } else if (colorsCounter === 1) {
                colorsCounterText = 'Available in 1 more color'
            }

            const raw = `
                <a class="suggested-product__image" href="${productURL}">
                    <img src="${src}" alt="${alt}" />
                </a>

                <div class="suggested-product__info flex f-dir-column f-space-between">
                    ${collectionText}
                    <h2 class="suggested-product__info-title title--xxs"><a href="${productURL}">${productTitle}</a></h2>
                    <span class="product-price">${productPrice}</span>
                    <span class="suggested-product__info-counter">${colorsCounterText}</span>
                </div>

            `

            const suggestedProduct = document.createElement('div')
            suggestedProduct.classList.add('suggested-product', 'flex')
            suggestedProduct.innerHTML = raw

            this._suggestedItemsContainer.appendChild(suggestedProduct)
        }
    }

    initCloseBtns () {
        const header = document.querySelector('#shopify-section-site-header')

        this._closeBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                if (window.scrollY < 50 && window.location.pathname === '/') {
                    header.classList.add('transparent')
                }
            })
        })
    }
}

export default Search



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Search.js